<template>
  <div style="display:inline-block">
    <qc-icon type="loading" v-if="!domainType"></qc-icon>
    <template v-else>
      <qc-select v-model="domainType" type="button" :options="domainTypeSelectList" class="custom-qc-select-130"
        :class="selectClass">
      </qc-select>
      <qc-select v-show="domainType === 'customCdn' || domainType === 'customCos' ||
        (domainType === 'defaultCdn' && showDefaultCdnDomain)" v-model="innerDomain" type="button"
        :options="domainSelectList" class="custom-qc-select-220" :class="selectClass"></qc-select>
    </template>
  </div>
</template>

<script>
import { getInnerProps } from '@/scripts/tools/utils';
import cos from '@/scripts/helper/cos';
import dao from '@/scripts/helper/dao';

export default {
  model: {
    prop: 'domain',
    event: 'update:domain',
  },
  props: {
    domain: {
      type: String,
      default: '',
    },
    bucket: {
      type: String,
      default: '',
    },
    region: {
      type: String,
      default: '',
    },
    openWebsite: {
      type: Boolean,
      default: false,
    },
    showDefaultCdnDomain: {
      type: Boolean,
      default: false,
    },
    selectClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      initDomain: '',
      initDomainType: '',
      domainType: '',
      domainTypeMap: this.$t('cos.domainTypeMap'),

      defaultCosList: [], // 默认源站域名
      defaultWebsiteList: [], // 默认静态网站域名
      defaultCdnList: [], // 默认加速域名
      customCdnList: [], // 自定义加速域名
      customCosList: [], // 自定义源站域名
    };
  },
  computed: {
    /**
        内部参数传递
      */
    innerDomain: getInnerProps('domain'),
    domainTypeSelectList() {
      const selectList = [];
      Object.keys(this.domainTypeMap).forEach(key => {
        const list = this[`${key}List`];
        if (list && list.length) {
          selectList.push({
            label: this.domainTypeMap[key],
            value: key,
            title: this.domainTypeMap[key],
          });
        }
      });
      return selectList;
    },
    domainSelectList() {
      const list = this[`${this.domainType}List`] || [];
      return list.map(item => ({
        label: item.domain,
        value: item.domain,
        title: item.domain,
        type: this.domainType,
      }));
    },
  },
  watch: {
    domainSelectList(list) {
      // 在初次进入有domain赋值的情况下，将innerDomain赋值为innerDomain，然后对initDomain和initDomainType清空，防止后续影响逻辑
      if (this.initDomain && list && list[0].type === this.initDomainType) {
        this.innerDomain = this.initDomain;
        this.initDomain = '';
        this.initDomainType = '';
        return;
      }
      if (list && list.length) {
        this.innerDomain = list[0].value;
      } else {
        this.innerDomain = '';
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initDomain = this.domain;
      Promise.all([
        this.initDefaultCosList(),
        this.initCustomCosList(),
        this.initCdnList(),
        this.initDefaultWebsiteList(),
      ]).then(() => {
        const allDomainObject = [
          ...this.defaultCosList,
          ...this.defaultCdnList,
          ...this.defaultWebsiteList,
          ...this.customCdnList,
          ...this.customCosList,
        ];
        // 此处作用主要在于，当本地存储的下载域名并不存在于所有下载域名时（如本地存储的是默认加速域名，但是控制台关掉默认加速域名，就会报错），方便父组件进行比对，避免父组件计算错误，用户无法手动更改
        this.$emit('on-getAllDownloadDomain', allDomainObject);
        this.innerDomain = this.initDomain;
        const len = this.domainTypeSelectList.length;
        for (let i = 0; i < len; i++) {
          const item = this.domainTypeSelectList[i];
          const { value } = item;
          const list = this[`${value}List`] || [];
          if (list.some(this.findDomainType)) {
            this.initDomainType = value;
            this.domainType = value;
            break;
          }
        }
      });
    },
    findDomainType(ele) {
      return ele.domain === this.initDomain;
    },
    initDefaultCosList() {
      return new Promise(resolve => {
        const { bucket, region } = this;
        this.defaultCosList = [
          {
            domain: cos.getDefaultBucketDomain({
              Bucket: bucket,
              Region: region,
              Key: '/',
            }),
          },
        ];
        resolve();
      });
    },
    initDefaultWebsiteList() {
      return new Promise(resolve => {
        const { bucket: Bucket, region: Region } = this;
        if (this.openWebsite) {
          this.defaultWebsiteList = [
            {
              domain: `${Bucket}.cos-website.${Region}.myqcloud.com`,
            },
          ];
        } else {
          this.defaultWebsiteList = [];
        }
        resolve();
      });
    },
    initCdnList() {
      return new Promise(resolve => {
        const { bucket: Bucket, region: Region } = this;
        dao
          .getBucketCustomizeCdnHostNew({ Bucket, Region })
          .then(data => {
            this.defaultCdnList = data.defaultCdnList;
            this.customCdnList = data.customCdnList;
            resolve();
          })
          .catch(() => {
            this.defaultCdnList = [];
            this.customCdnList = [];
            resolve();
          });
      });
    },
    initCustomCosList() {
      return new Promise(resolve => {
        const { bucket: Bucket, region: Region } = this;
        cos.getBucketDomain({ Bucket, Region }, (err, data) => {
          if (data) {
            this.customCosList = [];
            data.DomainRule.forEach(item => {
              if (item.Status === 'ENABLED') {
                this.customCosList.push({
                  domain: item.Name,
                  status: item.Status,
                  type: 'cos',
                });
              }
            });
          } else {
            this.customCosList = [];
          }
          resolve();
        });
      });
    },
  },
};
</script>

<style lang="scss">
.custom-qc-select-130 {
  min-width: 130px;
  &.tc-15-dropdown {
    .tc-15-dropdown-link,
    .tc-15-dropdown-menu {
      min-width: 130px;
      border-color: rgba(211, 222, 235, 0.9);
      margin-right: 5px;
    }
  }
}
.custom-qc-select-220 {
  width: 220px;
  &.tc-15-dropdown {
    .tc-15-dropdown-link,
    .tc-15-dropdown-menu {
      width: 220px;
      border-color: rgba(211, 222, 235, 0.9);
    }
  }
}
</style>
